import { floor } from "@suse-o11y/floor";
import { min } from "@suse-o11y/min";

const VALUE_FONT_SIZE_HEIGHT_COEFFICIENT = 0.5;
const VALUE_FONT_SIZE_WIDTH_COEFFICIENT = 1.3;

export function autoValueFontSize(width: number, height: number, textLength: number): number {
	const calculated = min(
		VALUE_FONT_SIZE_HEIGHT_COEFFICIENT * height,
		(VALUE_FONT_SIZE_WIDTH_COEFFICIENT * width) / textLength,
	);

	return floor(calculated, 0);
}
